import { render, staticRenderFns } from "./AppleHunterPrivacyPage.vue?vue&type=template&id=085eab5e&scoped=true"
import script from "./AppleHunterPrivacyPage.vue?vue&type=script&lang=ts"
export * from "./AppleHunterPrivacyPage.vue?vue&type=script&lang=ts"
import style0 from "./AppleHunterPrivacyPage.vue?vue&type=style&index=0&id=085eab5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085eab5e",
  null
  
)

export default component.exports